import type { ZudokuConfig } from "zudoku";

import posthogPlugin from "./src/plugins/posthog";

import Pricing from "./src/Pricing";

const config: ZudokuConfig = {
  site: {
    title: "Sparkscan API",
    logo: {
      src: {
        light: "light.svg",
        dark: "dark.svg",
      },
    },
    footer: {
      position: "center",
      copyright: `© ${new Date().getFullYear()} Polarity Ln, Inc. All rights reserved.`,
      social: [
        { icon: "github", href: "https://github.com/flashnetxyz" },
        { icon: "x", href: "https://x.com/flashnet" },
        { icon: "discord", href: "https://discord.gg/ATftcswWjt" },
      ],
      // columns: [
      //   {
      //     position: 'center',
      //     title: "Legal",
      //     links: [
      //       { label: "Privacy Policy", href: "https://sparkscan.io/privacy-policy" },
      //       { label: "Terms of Service", href: "https://sparkscan.io/terms-of-service" },
      //     ],
      //   }
      // ]
    },
    showPoweredBy: false,
  },
  metadata: {
    title: "Sparkscan API",
    description: "Sparkscan API",
    favicon: "/favicon.ico"
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          collapsed: false,
          items: [
            { type: "doc", file: "introduction" },
            { type: "doc", file: "api-keys" },
          ],
        },
        {
          type: "category",
          label: "Live Updates",
          icon: "sparkles",
          items: [
            { type: "doc", file: "live/introduction" },
            {
              type: "doc", file: "live/transactions-channel", badge: {
                label: "Beta",
                color: "yellow"
              }
            },
          ],
        },
      ],
    },
    {
      type: "category",
      label: "Errors",
      icon: "alert-circle",
      items: [
        { type: "doc", file: "errors/error-responses" },
        {
          type: "category",
          label: "Cases",
          icon: "logs",
          collapsed: false,
          items: [
            { type: "doc", file: "errors/cases/key-migration" },
            { type: "doc", file: "errors/cases/quota-exceeded" },
            { type: "doc", file: "errors/cases/key-leaked" },
            { type: "doc", file: "errors/cases/rate-limit-exceeded" },
            { type: "doc", file: "errors/cases/no-organization-membership" },
            { type: "doc", file: "errors/cases/no-subscription" }
          ]
        }
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  search: {
    type: "pagefind",
    maxSubResults: 3,
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  apis: [
    {
      type: "file",
      input: "./apis/routes.oas.json",
      path: "api",
      options: {
        examplesLanguage: "shell",
        disablePlayground: false,
        schemaDownload: { enabled: true },
      },
    },
  ],
  theme: {
    registryUrl: "https://tweakcn.com/r/themes/cmdxe3umg000304i97qeuf95f"
  },
  mdx: {
    components: {
      Pricing,
    },
  },
  docs: {
    files: "pages/**/*.{md,mdx}", // Your markdown files
    publishMarkdown: true, // Generate .md files
    llms: {
      llmsTxt: true, // Generate llms.txt
      llmsTxtFull: true, // Generate llms-full.txt
      includeProtected: false, // Exclude protected routes
    },
  },
  plugins: [posthogPlugin],
};

export default config;
